// import { ALGOLIA_PRODUCT_INDEX } from 'utils/analytics/algolia'
import { SortBy } from 'react-instantsearch-dom'
// import useAppState from 'utils/state'

export default function Sort({def}) {
    // const { coupon } = useAppState()

    // const defaultIndex = `${ALGOLIA_PRODUCT_INDEX}${coupon && coupon.code && !coupon.account_slug ? '' : ''}`
    // const defaultIndex = `${ALGOLIA_PRODUCT_INDEX}${coupon && coupon.code && !coupon.account_slug ? '_discount' : ''}`

    return (
        <SortBy
            defaultRefinement={def ? def : 'products/sort/in_stock:desc'}
            items={[
                // {
                //     value: 'default',
                //     label: 'Rūšiavimas'
                // },
                // {
                //     value: `new`,
                //     label: 'Naujausios'
                // },
                // {
                //     value: `min_price`,
                //     label: 'Žemiausia kaina'
                // },
                // {
                //     value: `max_price`,
                //     label: 'Aukščiausia kaina'
                // },
                // {
                //     value: `best_rating`,
                //     label: 'Geriausias vertinimas'
                // }
                { label: "Rekomenduojamos", value: "products/sort/in_stock:desc,default" },
                { label: "Naujausios", value: "products/sort/in_stock:desc,created_at:desc" },
                { label: "Populiariausios", value: "products/sort/in_stock:desc,previews:desc" },
                { label: "Geriausias vertinimas", value: "products/sort/in_stock:desc,review_rating:desc" },
                { label: "Didžiausia nuolaida", value: "products/sort/in_stock:desc,percentage_discount:desc" },
                { label: "Žemiausia kaina", value: "products/sort/in_stock:desc,price_from:asc" },
                { label: "Aukščiausia kaina", value: "products/sort/in_stock:desc,price_to:desc" },
            ]}
        />
    )
}

// export default function Sort() {
//     return null
// }
// import { ALGOLIA_PRODUCT_INDEX } from 'utils/analytics/algolia'
// import { SortBy } from 'react-instantsearch-dom'
// import useAppState from 'utils/state'

// export default function Sort() {
//     const { coupon } = useAppState()

//     const defaultIndex = `${ALGOLIA_PRODUCT_INDEX}${coupon && coupon.code && !coupon.account_slug ? '_discount' : ''}`

//     return (
//         <SortBy
//             defaultRefinement={defaultIndex}
//             items={[
//                 {
//                     value: defaultIndex,
//                     label: 'Rūšiavimas'
//                 },
//                 // {
//                 //     value: `${ALGOLIA_PRODUCT_INDEX}_created_desc`,
//                 //     label: 'Naujausios'
//                 // },
//                 {
//                     value: `${ALGOLIA_PRODUCT_INDEX}_price_asc`,
//                     label: 'Žemiausia kaina'
//                 }
//                 // {
//                 //     value: `${ALGOLIA_PRODUCT_INDEX}_price_desc`,
//                 //     label: 'Aukščiausia kaina'
//                 // }
//             ]}
//         />
//     )
// }

